// src/payment/index.ts
var STRIPE_METHOD_TYPES = /* @__PURE__ */ new Map([
  ["card", "card"],
  ["us_bank_account", "bank"]
]);
function toPaymentMethodType(stripeType) {
  if (!stripeType) return null;
  return STRIPE_METHOD_TYPES.get(stripeType) ?? null;
}
function detectPaymentProvider(paymentSettings) {
  if (!paymentSettings) return null;
  if (paymentSettings.provider) return paymentSettings.provider;
  if (paymentSettings.stripe?.publishableKey || paymentSettings.stripe?.secretKey) {
    return "stripe";
  }
  if (paymentSettings.square?.applicationId || paymentSettings.square?.accessToken) {
    return "square";
  }
  return null;
}
function isPaymentProviderConfigured(paymentSettings, provider = "stripe") {
  if (!paymentSettings) return false;
  if (provider === "stripe") {
    return !!paymentSettings.stripe?.publishableKey;
  }
  if (provider === "square") {
    return !!(paymentSettings.square?.applicationId && paymentSettings.square?.locationId);
  }
  return false;
}

export { detectPaymentProvider, isPaymentProviderConfigured, toPaymentMethodType };
//# sourceMappingURL=index.js.map
//# sourceMappingURL=index.js.map